var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "350", "retain-focus": false },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "navy pa-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "navy white--text d-flex align-center font-hemi-head",
            },
            [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _vm._v(
                  "Scegli calciatore (acquistato) da visualizzare nello slot\n        cliccato"
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dismiss()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text--text text--lighten-2" }, [
            _vm._v(
              "\n      Scegli quale calciatore, tra quelli che hai acquistato, inserire nello\n      slot cliccato."
            ),
            _c("br"),
            _vm._v(
              "\n      I crediti spesi realmente si sostituiranno a quelli pianificati in\n      quello slot e il sistema ti suggerirá come pianificare la differenza.\n      "
            ),
            _c("br"),
            _vm._v(
              '\n      Non preoccuparti, potrai sempre rimuoverlo da queesto slot (cliccando\n      sulla "x") e associarlo a un altro slot (cliccando sul "+")\n    '
            ),
          ]),
          _vm._v(" "),
          _c("asta-rosa", {
            staticClass: "pt-4",
            attrs: {
              id_squadra: _vm.id_squadra,
              hideCalciatoriImages: "",
              hideEditRemove: "",
              ripple: "",
              onCalciatoreClick: _vm.associa,
              ruolo_id: _vm.ruolo_id,
              escludi_ids: _vm.associati,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }